import { css as p, LitElement as b, html as v } from "lit";
import { property as s, state as w, customElement as u } from "lit/decorators.js";
import { classMap as c } from "lit/directives/class-map.js";
import { b as d } from "./styles-scZ6dVz-.js";
var m = Object.defineProperty, g = Object.getOwnPropertyDescriptor, o = (t, l, e, a) => {
  for (var i = a > 1 ? void 0 : a ? g(l, e) : l, h = t.length - 1, n; h >= 0; h--)
    (n = t[h]) && (i = (a ? n(l, e, i) : n(i)) || i);
  return a && i && m(l, e, i), i;
};
let r = class extends b {
  constructor() {
    super(...arguments), this.type = "auto", this.size = "md", this.orientation = "both", this.shrinkContent = !1, this._isScrolling = !1, this._handleScroll = () => {
      this.type === "hover" && (this._isScrolling = !0, this._scrollTimeout && window.clearTimeout(this._scrollTimeout), this._scrollTimeout = window.setTimeout(() => {
        this._isScrolling = !1;
      }, 1e3)), this.dispatchEvent(
        new CustomEvent("ark-scroll", {
          detail: {
            scrollTop: this._viewportRef?.scrollTop ?? 0,
            scrollLeft: this._viewportRef?.scrollLeft ?? 0,
            scrollHeight: this._viewportRef?.scrollHeight ?? 0,
            scrollWidth: this._viewportRef?.scrollWidth ?? 0,
            clientHeight: this._viewportRef?.clientHeight ?? 0,
            clientWidth: this._viewportRef?.clientWidth ?? 0
          },
          bubbles: !0,
          composed: !0
        })
      );
    }, this._captureViewportRef = (t) => {
      this._viewportRef = t;
    };
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this._scrollTimeout && window.clearTimeout(this._scrollTimeout);
  }
  /** Scroll to a specific position */
  scrollToPosition(t) {
    this._viewportRef?.scrollTo(t);
  }
  /** Scroll to the top */
  scrollToTop(t = "smooth") {
    this._viewportRef?.scrollTo({ top: 0, behavior: t });
  }
  /** Scroll to the bottom */
  scrollToBottom(t = "smooth") {
    this._viewportRef && this._viewportRef.scrollTo({
      top: this._viewportRef.scrollHeight,
      behavior: t
    });
  }
  render() {
    const t = {
      "scroll-area": !0,
      [`type-${this.type}`]: !0,
      [`size-${this.size}`]: !0,
      "horizontal-only": this.orientation === "horizontal",
      "vertical-only": this.orientation === "vertical",
      scrolling: this._isScrolling
    }, l = {
      content: !0,
      "no-min-width": this.shrinkContent || this.orientation === "vertical",
      "no-min-height": this.shrinkContent || this.orientation === "horizontal"
    }, e = [];
    return this.maxHeight && e.push(`max-height: ${this.maxHeight}`), this.maxWidth && e.push(`max-width: ${this.maxWidth}`), v`
      <div class=${c(t)}>
        <div
          part="viewport"
          class="viewport"
          style=${e.join("; ")}
          @scroll=${this._handleScroll}
          ${this._captureViewportRef}
        >
          <div class=${c(l)}>
            <slot></slot>
          </div>
        </div>
      </div>
    `;
  }
  firstUpdated() {
    this._viewportRef = this.shadowRoot?.querySelector(".viewport");
  }
};
r.styles = [
  d,
  p`
      :host {
        display: block;
        overflow: hidden;
        position: relative;
      }

      *,
      *::before,
      *::after {
        box-sizing: border-box;
      }

      .scroll-area {
        --scrollbar-size: var(--r5-scrollbar-size, 8px);
        --scrollbar-thumb-bg: var(--r5-scrollbar-thumb-bg, var(--r5-color-neutral-400));
        --scrollbar-thumb-hover-bg: var(--r5-scrollbar-thumb-hover-bg, var(--r5-color-neutral-500));
        --scrollbar-track-bg: var(--r5-scrollbar-track-bg, transparent);

        position: relative;
        width: 100%;
        height: 100%;
      }

      .viewport {
        width: 100%;
        height: 100%;
        overflow: auto;
        scrollbar-width: thin;
        scrollbar-color: var(--scrollbar-thumb-bg) var(--scrollbar-track-bg);
      }

      /* WebKit scrollbar styling */
      .viewport::-webkit-scrollbar {
        width: var(--scrollbar-size);
        height: var(--scrollbar-size);
      }

      .viewport::-webkit-scrollbar-track {
        background: var(--scrollbar-track-bg);
        border-radius: var(--r5-radius-full);
      }

      .viewport::-webkit-scrollbar-thumb {
        background: var(--scrollbar-thumb-bg);
        border-radius: var(--r5-radius-full);
        border: 2px solid transparent;
        background-clip: padding-box;
      }

      .viewport::-webkit-scrollbar-thumb:hover {
        background: var(--scrollbar-thumb-hover-bg);
        background-clip: padding-box;
      }

      .viewport::-webkit-scrollbar-corner {
        background: var(--scrollbar-track-bg);
      }

      /* Scrollbar visibility types */
      .type-auto .viewport {
        overflow: auto;
      }

      .type-always .viewport {
        overflow: scroll;
      }

      .type-scroll .viewport {
        overflow: scroll;
      }

      .type-hover .viewport {
        overflow: hidden;
      }

      .type-hover:hover .viewport,
      .type-hover.scrolling .viewport {
        overflow: auto;
      }

      /* Hide scrollbar when type is hover and not hovering */
      .type-hover .viewport::-webkit-scrollbar-thumb {
        background: transparent;
      }

      .type-hover:hover .viewport::-webkit-scrollbar-thumb,
      .type-hover.scrolling .viewport::-webkit-scrollbar-thumb {
        background: var(--scrollbar-thumb-bg);
      }

      /* Orientation */
      .horizontal-only .viewport {
        overflow-x: auto;
        overflow-y: hidden;
      }

      .vertical-only .viewport {
        overflow-x: hidden;
        overflow-y: auto;
      }

      /* Size presets */
      .size-sm {
        --scrollbar-size: 6px;
      }

      .size-md {
        --scrollbar-size: 8px;
      }

      .size-lg {
        --scrollbar-size: 12px;
      }

      /* Content wrapper */
      .content {
        min-width: max-content;
        min-height: max-content;
      }

      .content.no-min-width {
        min-width: unset;
      }

      .content.no-min-height {
        min-height: unset;
      }
    `
];
o([
  s({ type: String, reflect: !0 })
], r.prototype, "type", 2);
o([
  s({ type: String, reflect: !0 })
], r.prototype, "size", 2);
o([
  s({ type: String, reflect: !0 })
], r.prototype, "orientation", 2);
o([
  s({ type: String, attribute: "max-height" })
], r.prototype, "maxHeight", 2);
o([
  s({ type: String, attribute: "max-width" })
], r.prototype, "maxWidth", 2);
o([
  s({ type: Boolean, attribute: "shrink-content" })
], r.prototype, "shrinkContent", 2);
o([
  w()
], r.prototype, "_isScrolling", 2);
r = o([
  u("ark-scroll-area")
], r);
export {
  r as A
};
//# sourceMappingURL=ark-scroll-area-CLZ0tXeO.js.map
